module.exports = __webpack_public_path__ + "assets/img/banner-frase-1920.jpg";